import { EMAIL_REGEX } from 'constants/constants';

/**
 * Gets the width of browser window
 * @returns {number}
 */
const screenSize = () => {
  return (
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth
  );
};

/**
 * Reloads the current page without search params
 * @param {object} element - DOM Element
 */
const clearSearchParams = element => {
  element.addEventListener('click', e => {
    e.preventDefault();
    window.location = window.location.href.split('?')[0];
  });
};

/**
 * Validates an email
 * @param {string} email
 * @returns true or false
 */
const isValidEmail = email => EMAIL_REGEX.test(String(email).toLowerCase());

const isMobileDevice = () => {
  if (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/.test(
      navigator.userAgent,
    )
  ) {
    return true;
  }
  return false;
};

/**
 * Capitalise First Letter of String
 * @param {string} word
 * @returns string
 */
const capitaliseFirstLetter = word =>
  word.charAt(0).toUpperCase() + word.toLowerCase().slice(1);

const handleUnit = unit => {
  let value;

  switch (unit) {
    case 'm':
    case 'kg':
      value = unit;
      break;
    case 'each':
    case 'Each':
      value = '';
      break;
    default:
      value = ` ${unit}`;
  }

  return value;
};

const specialCharCheck = e => {
  const specialChars = /[^a-zA-Z0-9\-\\/. +]/g;
  if (e.match(specialChars)) {
    return true;
  }
  return false;
};

const createBasketJSON = orders => {
  const lines_attributes = {};
  orders.map((order, index) => {
    lines_attributes[index] = {
      product_id: order.product_id,
      quantity: parseInt(order.quantity),
    };
  });

  const basket = {
    basket: {
      lines_attributes,
      skip_back_order_check: 'true',
    },
  };
  return basket;
};

const displaySuccessfulUpdate = data => {
  setTimeout(() => {
    const basketInfoWrapper = document.querySelector(
      '.basket-preview-price-wrapper',
    );
    const basketItems = basketInfoWrapper.querySelector('.basket-items');
    const basketPreviewPrice = basketInfoWrapper.querySelector(
      '.basket-preview-price',
    );
    const basketCount = basketInfoWrapper.querySelector('.basket-count');
    basketInfoWrapper.classList.remove('is-loading');
    if (data) {
      basketItems.innerHTML = data.lines;
      basketPreviewPrice.innerHTML = data.total;
      basketCount.innerHTML = data.mobile_count;
    }
  }, 2500);
};

/**
 * Creates a unique array of objects by the key
 * e.g
 * const array = [ { id: 1}, {id: 1}]
 * returns: [ { id: 1}]
 * @param {Array} arr - the array to sort
 * @returns a unique array
 */
const uniqueByKey = (arr, key) => [
  ...new Map(arr.map(v => [v[key], v])).values(),
];

/**
 *
 * @param {value} value - e.g. 2199.00
 * @returns 2,199.00
 */
const formatCurrency = value =>
  typeof value === 'string'
    ? value.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    : value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');

export {
  screenSize,
  clearSearchParams,
  isValidEmail,
  isMobileDevice,
  capitaliseFirstLetter,
  handleUnit,
  specialCharCheck,
  createBasketJSON,
  displaySuccessfulUpdate,
  uniqueByKey,
  formatCurrency,
};
